export function useSearchHint({ search, minSearchLength = 3 }) {
  const searchHint = computed(() => {
    if (!unref(search)?.trim()) {
      return "";
    }

    if (unref(search)?.trim()?.length >= minSearchLength) {
      return "";
    }

    return `Min ${minSearchLength} characters are required for search`;
  });

  return {
    searchHint,
  };
}
